import request from '@/request'
import { PublicHeader } from '../../../components/common/'
export default {
  name: 'escalas',
  created() {
    this.isCreating = true
    this.loadMonths()
    this.setCurrentMonth()
    this.setFirstWeekOfMonth()
    this.generateWeek()
    this.loadUors()
  },
  mounted() {
    scroll(0, 0)
  },
  data() {
    return {
      uors: [],
      uor: '',
      months: [],
      month: 0,
      week: [],
      weekStart: null,
      weekEnd: null,
      search: '',
      scale: [],
      isCreating: false,
      loadingScale: false,
      observacao: 'Não há observação para está escala.'
    }
  },
  components: {
    PublicHeader
  },
  watch: {
    uor(value) {
      if (value) {
        this.loadScale()
        this.loadObservacao()
      }
    }
  },
  computed: {
    queryParams() {
      let queryParams = [
        `referencia=${this.months[this.month].referencia}`,
        `semana=${this.week.map(({ data }) => (data)).join(',')}`
      ]

      if (this.search) {
        queryParams.push(`filter=${search}`)
        this.uor = ''
      }

      if (this.uor) queryParams.push(`uor_sigla=${this.uor}`)

      return queryParams
    }
  },
  methods: {
    loadScale() {
      if (this.uor === "") return

      const { queryParams } = this

      this.loadingScale = true

      request.get(
        `escalas?${queryParams.join('&')}`,
        response => {
          this.scale = response
          this.loadingScale = false
        },
        error => {
          this.loadingScale = false
          console.log(error)
        }
      )
    },
    loadObservacao() {
      this.$nextTick(() => {
        this.observacao = "Carregando observação..."

        request.get(
          `escala/observacao-sigla-referencia?uor_sigla=${this.uor}&referencia=${this.months[this.month].referencia}`,
          response => {
            this.observacao = response
          },
          error => {
            this.observacao = "Houve um erro ao tentar carregar a observação desta escala!"
            console.log(error)
          }
        )
      })
    },
    loadUors() {
      const me = this
      const { referencia } = this.months[this.month]
      request.get(
        `listar-unidades-associadas?referencia=${referencia}`,
        response => me.uors = response,
        error => console.log(error),
      )
    },
    loadMonths() {
      let date = new Date()
      for (let index = 0; index < 12; index++) {
        date.setMonth(index)
        this.months.push({
          label: date.toLocaleDateString('pt-BR', {
            month: 'long',
            year: 'numeric'
          }),
          value: index,
          referencia: date.toISOString().split('T')[0].replace('-', '').substring(0, 6)
        })
      }
    },
    setCurrentMonth() {
      let date = new Date()
      this.month = date.getMonth()
    },
    setFirstWeekOfMonth() {
      let date = new Date()
      date.setDate(1)
      date.setMonth(this.month)
      date.setDate(date.getDate() - date.getDay())

      this.weekStart = new Date(date.getTime())

      date.setDate(date.getDate() + 6)

      this.weekEnd = new Date(date.getTime())
    },
    generateWeek() {
      let seekDate = new Date(this.weekStart.getTime())
      this.week = []
      do {
        this.week.push({
          weekday: seekDate
            .toLocaleDateString('pt-BR', { weekday: 'short' })
            .replace('.', ''),
          monthday: seekDate.getDate(),
          dayIndex: seekDate.toLocaleDateString('pt-BR', { day: '2-digit' }),
          data: seekDate.toLocaleDateString().substring(0, 5)
        })
        seekDate.setDate(seekDate.getDate() + 1)
      } while (seekDate.getTime() <= this.weekEnd.getTime())
    },
    dateFormatDDMM(date) {
      return ` ${date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit'
      })} `
    },
    handleSelectedMonth() {
      this.setFirstWeekOfMonth()
      this.generateWeek()
      this.loadUors()
    },
    nextWeek() {
      this.navWeek(7)
    },
    prevWeek() {
      this.navWeek(-7)
    },
    navWeek(days) {
      this.weekStart.setDate(this.weekStart.getDate() + days)
      this.weekEnd.setDate(this.weekEnd.getDate() + days)
      this.month = this.weekStart.getMonth()

      this.generateWeek()
      this.loadScale()
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/public/escalas/escalas.js